'use strict';

const ALERT_SELECTOR = '.js-alert';
const DEFAULT_TIMEOUT = 7000;

let hideTimer = null;
let pendingOnHide = null;

/**
 * Hides the alert shell. Optionally runs the last onHide callback.
 * @param {boolean} [runCallback=false] - Whether to run the last onHide callback
 */
function hide(runCallback) {
    const $root = $(ALERT_SELECTOR).first();
    const onHide = pendingOnHide;

    if (hideTimer) {
        window.clearTimeout(hideTimer);
        hideTimer = null;
    }

    pendingOnHide = null;

    if ($root.length) {
        $root.attr('hidden', true);
        $root.removeClass('site-alert--success site-alert--error');
        $root.find('.site-alert__text').removeClass('is-in');
        $root.find('.js-alert-link-wrap').attr('hidden', true);
        $root.attr('role', 'status');
    }

    if (runCallback && typeof onHide === 'function') onHide();
}

/**
 * Shows an alert in the layout shell. No-op when the shell is not on the page.
 * @param {Object} options - Alert options
 */
function show(options) {
    const config = options || {};
    const $root = $(ALERT_SELECTOR).first();

    if (!config.message || !$root.length) return;

    const type = config.type === 'error' ? 'error' : 'success';
    const timeout = config.timeout != null
        ? config.timeout
        : (Number($root.attr('data-timeout')) || DEFAULT_TIMEOUT);
    const $card = $root.find('.site-alert__text');
    const cardEl = $card.get(0);
    const $linkWrap = $root.find('.js-alert-link-wrap');
    const link = config.link || {};
    const showLink = type === 'success' && link.href && link.text;

    hide(false);

    $root
        .removeClass('site-alert--success site-alert--error')
        .addClass(`site-alert--${type}`)
        .attr('role', type === 'error' ? 'alert' : 'status')
        .removeAttr('hidden');

    $root.find('.js-alert-message').text(
        showLink ? config.message.replace(/[.!?]+$/, '') : config.message
    );

    if (showLink) {
        $root.find('.js-alert-link').attr('href', link.href).text(link.text);
        $linkWrap.removeAttr('hidden');
    } else {
        $linkWrap.attr('hidden', true);
    }

    $card.removeClass('is-in');

    if (cardEl) cardEl.offsetWidth;

    $card.addClass('is-in');

    pendingOnHide = config.onHide || null;

    if (timeout > 0) {
        hideTimer = window.setTimeout(function () {
            hide(true);
        }, timeout);
    }
}

module.exports = {
    show: show,
    hide: function () {
        hide(false);
    }
};
